import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Toast } from 'ngx-toastr';

/**
 * This component is a custom toast component that follows the Labcorp Bootstrap theme.
 *
 * It is used by default by the ngx-toastr library. The configuration that specifies that
 * is in the app.config.ts file.
 *
 * Alternate custom toast components can be used on an adhoc basis if needed.
 */
@Component({
    selector: 'acm-lcbs-toast',
    imports: [CommonModule, MatIcon],
    templateUrl: './lcbs-toast.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LcBsToastComponent extends Toast {
    // Map ngx-toastr's toastType (one of toast-info, toast-success, toast-warning,
    // toast-error -- per the iconClasses config in DefaultNoComponentGlobalConfig)
    // to a Material Symbols Rounded glyph name.
    //
    // The warning/error swap mirrors the upstream labcorp-bootstrap ngx-toastr
    // SCSS, which intentionally renders 'error' for toast-warning and 'warning'
    // for toast-error.
    private static readonly TOAST_TYPE_ICONS: Record<string, string> = {
        'toast-info': 'info',
        'toast-success': 'check_circle',
        'toast-warning': 'error',
        'toast-error': 'warning',
    };

    protected readonly iconForToastType = computed(() => {
        const type = this.toastPackage.toastType;
        return LcBsToastComponent.TOAST_TYPE_ICONS[type] ?? 'info';
    });
}
